import React from 'react'
import SVG from 'react-inlinesvg';
import {styledComponent, getVal, getValFromTheme} from '/app/src/hoc'
import {Flex} from '/app/src/component'
import Modal from 'react-responsive-modal';

class SVGButton extends React.Component {
    constructor(props){
        super(props)
        this.state = {
            showConfirmation: false
        }
        this._onClick = this._onClick.bind(this)
        this._renderModal = this._renderModal.bind(this)
    }
    _onClick(e){
        e.stopPropagation();
        e.target.value = this.props.text
        if(this.props.showConfirm){
            this.setState({showConfirmation:true})
            return;
        }

        if(this.props.onClick) this.props.onClick(e)
    }
    _renderModal(){
        return <Modal
            open={this.state.showConfirmation}
                onClose={()=>{this.setState({showConfirmation: false})}}
                styles={{
                    'modal': {
                        'padding': '0px',
                        'borderRadius': '20px',
                        'backgroundColor': '#404040'
                    },
                    'overlay': {

                    },
                    'closeIcon': {
                        'fill': '#a5a5a5'
                    }
                }}
                >
                    <Flex column borderRadius='30px' width='700px' paddingBottom='30px' backgroundColor='white'>
                        <Flex w='100%' center backgroundColor='black' borderRadius='20px 20px 0 0'
                        padding='15px' color='blue' borderBottom='6px solid'
                        height='63px' fontSize='28px'

                        >
                            {this.props.confirmTitle}
                        </Flex>

                        <Flex column padding='30px 60px'>
                            {this.props.confirmContent}
                            <Flex center>
                                <Flex border='3px solid' w='179px'
                                    hover='blue'
                                    center cursor='pointer'
                                    onClick={()=>{this.props.onCancel(); this.setState({showConfirmation: false})}}
                                    height='63px' borderRadius='40px'
                                    fontSize='28px' fontWeight='500'
                                >
                                    <SVG cacheGetRequests={true} style={{'fill': 'currentColor', 'height': '34px', 'width': '34px'}}
                                    src='/images/Return.svg'/> Avbryt
                                </Flex>
                                <Flex w='20px'/>

                                <Flex
                                    border='3px solid' w='179px'
                                    hover='blue'
                                    center cursor='pointer'
                                    height='63px' borderRadius='40px'
                                    fontSize='28px' fontWeight='500'
                                    onClick={()=>{this.props.onClick(); this.setState({showConfirmation: false})}}
                                    >
                                        <SVG  cacheGetRequests={true} style={{'fill': 'currentColor', 'height': '34px', 'width': '34px'}}
                                        src={this.props.confirmButton.src}/> {this.props.confirmButton.text}
                                    </Flex>
                                <Flex w='20px'/>
                            </Flex>
                        </Flex>
                    </Flex>
                </Modal>
    }
    render() {
        let {src, text, cursor, disabled, iconPos, color, ...rest} = this.props
        if(this.state.showConfirmation) return this._renderModal();


        let onClick=this._onClick
        if(disabled){
            onClick=()=>{}
            cursor = 'default'
        }

        iconPos = iconPos || 'left'
        const isLeft = iconPos === 'left'
        return (
            <Flex
                dataImg={src}
                shrink={0}
                cursor={cursor || 'pointer'} center
                {...rest}
                onClick={onClick}>
                {src && isLeft && <SVG src={src} cacheGetRequests={true} /> }
                {text}
                {src && !isLeft && <SVG src={src} cacheGetRequests={true} /> }
                {this.props.children}
            </Flex>
        )
    }
}


function getBackgroundColor(props){
    if(props.disabled){
        return props.theme.colors.darklight
    }
    if(props.active){
        return getValFromTheme(props, ['backgroundActive','backgroundHover'], props.theme.colors)
    }
    return 'inherit'
}
function getColor(props){
    if(props.disabled)
        return props.theme.colors.lightgrey
    if(props.active)
        return getValFromTheme(props, ['colorActive','hover'], props.theme.colors)
    return getValFromTheme(props, ['color'], props.theme.colors)
}

// disabled stuff border need to be explicit
function getBorderColor(props){
    if(props.active && props.borderActive)
        return getValFromTheme(props, ['borderActive'], props.theme.colors)
    if(!props.border)
        return 'transparent'
    return getValFromTheme(props, ['borderColor'], props.theme.colors, 'transparent')
}

function getBorderHoverColor(props){
    if(props.active && props.borderActive)
        return getValFromTheme(props, ['borderActive'], props.theme.colors)
    if(!props.border)
        return 'transparent'
    if(props.disable)
        return 'MediumGrey5'
    return getValFromTheme(props, ['borderHover', 'borderColor'], props.theme.colors, 'MediumGrey5')
}

function getHoverColor(props){
    if(props.disabled){
        return props.theme.colors.lightgrey
    }
    return getValFromTheme(props, ['hover'], props.theme.colors)
}

function getPadding(props){
    const {children, src, text, iconPos} = props
    if(text && !src && !children)  // only text
        return '0 10px'
    if(src && text && iconPos !== 'right' && !children) // [image] text
        return '0px 10px 0px 0px'
    if(src && text && iconPos === 'right' && !children) // text [image]
        return '0px 0px 0px 10px'
    return '0'
}
const getSrc = (props)=>{
    if(props.active)
        return getVal(props, ['activeSrc','src'])
    if(props.disabled)
        return getVal(props, ['disabledSrc','src'])
    return getVal(props, ['src'])
}

const StyledSVGButton =  styledComponent(SVGButton, props => ({
        'backgroundColor':getBackgroundColor(props),
        'color': getColor(props),
        'user-select': 'none',
        'min-height': '10px',
        'min-width': '20px',
        'direction': props.direction?props.direction:'ltr',
        'border-radius': '30px',
        'fontWeight': '500',
        'fontSize': '21px',
        'padding': getPadding(props),
        'border': props.border?'3px solid':'3px solid transparent',
        'borderColor': getBorderColor(props),
        'display': getVal(props, ['display']),
        'src': getSrc(props),
        '> span':{
            height: getVal(props, ['h', 'height'], '40px'),
            width: getVal(props, ['h', 'height'], '40px'),
        },
        '> span > svg':{
            height: getVal(props, ['h', 'height'], '100%'),
            width: getVal(props, ['h', 'height'], 'auto'),
            'fill': getColor(props),
            'transform': 'scale(0.7)'
        },
        ':hover >span>svg': {
            'fill': getHoverColor(props),
        },
        ':hover': {
            color: getHoverColor(props)+ ' !important ',
            borderColor: getBorderHoverColor(props)
        },

}))

export default StyledSVGButton



// WEBPACK FOOTER //
// ./src/component/SVGButton/index.js